import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class InsightsService {
  private angularPlugin = new AngularPlugin();
  private appInsights?: ApplicationInsights;

  constructor(private router: Router) {
    const key: string | undefined = environment.appInsights?.instrumentationKey;
    const isDevelop: boolean = environment.environmentName === 'development';

    if (key && !isDevelop) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: key,
          extensions: [this.angularPlugin],
          extensionConfig: {
            [this.angularPlugin.identifier]: {
              router: this.router,
            },
          },
        },
      });
      this.appInsights.loadAppInsights();
    }
  }

  logEvent(name: string, properties?: Record<string, unknown>): void {
    this.appInsights?.trackEvent({ name: name }, properties);
  }

  logException(exception: Error, severityLevel?: number): void {
    this.appInsights?.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: Record<string, unknown>): void {
    this.appInsights?.trackTrace({ message: message }, properties);
  }
}
